/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Mode_Hint_ScoreInputs */



/**
* | output |
* | --- |
* | "Preliminary scores (game wins, VPs, tournament points) added up over the league's events." |
*
* @param {League_Mode_Hint_ScoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_mode_hint_score = /** @type {((inputs?: League_Mode_Hint_ScoreInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Mode_Hint_ScoreInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scores des rondes qualificatives (victoires de partie, VP, points de tournoi) additionnés sur les tournois de la ligue.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultados de las rondas clasificatorias (victorias de partida, VP, puntos de torneo) sumados en los torneos de la liga.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Resultados das rodadas classificatórias (vitórias de partida, VP, pontos de torneio) somados nos torneios da liga.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punteggi dei round preliminari (vittorie di partita, VP, punti torneo) sommati sui tornei del campionato.")
	return /** @type {LocalizedString} */ ("Preliminary scores (game wins, VPs, tournament points) added up over the league's events.")
});